export enum AppPaths {
  Applications = "/applications",
  ApplicationHistory = "/history/application",
  AccountOpeningApplication = "/applications/account/opening",
  AccountOpeningApplicationUpdate = "/applications/account/opening/:operationId/update",
  AccountOpeningApplicationCopy = "/applications/account/opening/:operationId/copy",
  AccountClosureApplication = "/applications/account/closure",
  AccountClosureApplicationUpdate = "/applications/account/closure/:operationId/update",
  AccountClosureApplicationCopy = "/applications/account/closure/:operationId/copy",
  PhoneBankingApplication = "/applications/phone-banking",
  PhoneBankingApplicationUpdate = "/applications/phone-banking/:operationId/update",
  PhoneBankingApplicationCopy = "/applications/phone-banking/:operationId/copy",
  PayrollCardOpeningApplication = "/applications/payroll-card-opening",
  PayrollCardOpeningApplicationUpdate = "/applications/payroll-card-opening/:operationId/update",
  PayrollCardOpeningApplicationCopy = "/applications/payroll-card-opening/:operationId/copy",
  PeriodicalPaymentsApplication = "/applications/periodical-payments",
  PeriodicalPaymentsApplicationUpdate = "/applications/periodical-payments/:operationId/update",
  PeriodicalPaymentsApplicationCopy = "/applications/periodical-payments/:operationId/copy",
  CardServiceInstructionApplication = "/applications/card-service-instruction",
  CardServiceInstructionApplicationUpdate = "/applications/card-service-instruction/:operationId/update",
  CardServiceInstructionApplicationCopy = "/applications/card-service-instruction/:operationId/copy",
  LoanTrancheDisbursementApplication = "/applications/loan-tranche-disbursement",
  LoanTrancheDisbursementApplicationUpdate = "/applications/loan-tranche-disbursement/:operationId/update",
  LoanTrancheDisbursementApplicationCopy = "/applications/loan-tranche-disbursement/:operationId/copy",
  DepositTerminationApplication = "/applications/deposit-termination",
  DepositTerminationApplicationUpdate = "/applications/deposit-termination/:operationId/update",
  DepositTerminationApplicationCopy = "/applications/deposit-termination/:operationId/copy",
  UserOpeningApplication = "/applications/user-opening",
  UserOpeningApplicationUpdate = "/applications/user-opening/:operationId/update",
  UserOpeningApplicationCopy = "/applications/user-opening/:operationId/copy",
  Login = "/auth/login",
  Two_Factor = "/auth/two-factor",
  Reset = "/auth/reset",
  New_Password = "/auth/new-password",
  Otp_Verification = "/auth/otp-verification",
  Dashboard = "/dashboard",
  Accounts = "/accounts",
  AccountHistory = "/accounts/:accountId/history",
  AccountStatement = "/accounts/:accountId/statement",
  AccountRequisites = "/accounts/:accountId/requisites",
  Transactions = "/transactions",
  Transaction = "/transaction",
  Templates = "/templates",
  TransactionHistory = "/history/transaction",
  AccountTransfer = "/transactions/transfer/account",
  AccountTransferUpdate = "/transactions/transfer/account/:operationId/update",
  AccountTransferCopy = "/transactions/transfer/account/:operationId/copy",
  CardTransfer = "/transactions/transfer/card",
  CardTransferUpdate = "/transactions/transfer/card/:operationId/update",
  CardTransferCopy = "/transactions/transfer/card/:operationId/copy",
  OwnAccountTransfer = "/transactions/transfer/own-account",
  OwnAccountTransferUpdate = "/transactions/transfer/own-account/:operationId/update",
  OwnAccountTransferCopy = "/transactions/transfer/own-account/:operationId/copy",
  BudgetTransfer = "/transactions/transfer/budget",
  BudgetTransferUpdate = "/transactions/transfer/budget/:operationId/update",
  BudgetTransferCopy = "/transactions/transfer/budget/:operationId/copy",
  CurrencyExchange = "/transactions/transfer/currency-exchange",
  CurrencyExchangeUpdate = "/transactions/transfer/currency-exchange/:operationId/update",
  CurrencyExchangeCopy = "/transactions/transfer/currency-exchange/:operationId/copy",
  GroupTransfer = "/transactions/transfer/group",
  GroupTransferUpdate = "/transactions/transfer/group/:operationId/update",
  GroupTransferCopy = "/transactions/transfer/group/:operationId/copy",
  LoanRepayment = "/transactions/transfer/loan-repayment",
  LoanRepaymentUpdate = "/transactions/transfer/loan-repayment/:operationId/update",
  LoanRepaymentCopy = "/transactions/transfer/loan-repayment/:operationId/copy",
  Cards = "/cards",
  CardHistory = "/cards/:cardId/history",
  CardStatement = "/cards/:cardId/statement",
  Loans = "/loans",
  LoanHistory = "/loans/:loanId/history",
  LoanSchedule = "/loans/:loanId/schedule",
  LoanStatement = "/loans/:loanId/statement",
  Stocks = "/stocks",
  Bonds = "/bonds",
  NotFound = "/*",
  Deposits = "/deposits",
  DepositHistory = "/deposits/:depositId/history",
  DepositStatement = "/deposits/:depositId/statement",
  DepositSchedule = "/deposits/:depositId/schedule",
  ExchangeRate = "/exchange-rate",
  AccountTransferTemplate = "/templates/account-transfer",
  AccountTransferTemplateUpdate = "/templates/account-transfer/:operationId/update",
  CardTransferTemplate = "/templates/card-transfer",
  CardTransferTemplateUpdate = "/templates/card-transfer/:operationId/update",
  OwnAccountTransferTemplate = "/templates/own-transfer",
  OwnAccountTransferTemplateUpdate = "/templates/own-transfer/:operationId/update",
  CurrencyExchangeTemplate = "/templates/currency-exchange",
  CurrencyExchangeTemplateUpdate = "/templates/currency-exchange/:operationId/update",
  LoanRepaymentTemplate = "/templates/loan-repayment",
  LoanRepaymentTemplateUpdate = "/templates/loan-repayment/:operationId/update",
  BudgetTransferTemplate = "/templates/budget-transfer",
  BudgetTransferTemplateUpdate = "/templates/budget-transfer/:operationId/update",
  Beneficiaries = "/beneficiaries",
  CreateBeneficiary = "/beneficiaries/create",
}

export enum CommonApiUrl {
  StopToolUrl = "v1/Configurations/StopTool/Url"
}

export enum ActionType {
  Sign = "sign",
  Save = "save",
}

export enum LanguageLabel {
  Hay = "Հայ",
  Eng = "Eng",
  Rus = "Rus"
}

export enum LanguageKey {
  En = "en",
  Hy = "hy",
  Ru = "ru"
}

export enum LanguageValue {
  en = "en-US",
  ru = "ru",
  hy = "hy",
}

export enum Theme {
  Light = "light",
  Dark = "dark",
  DataTheme = "data_theme",
  Theme = "theme",
}

export enum AnalyticsKey {
  DataGaId = "data-ga-id",
  DataGaAction = "data-ga-action",
  DataGaLabel = "data-ga-label",
}

export enum Challenge {
  Empty = "",
  NotSet = "NotSet",
  PasswordReset = "PasswordReset",
  Authentication = "Authentication",
  RequireUsername = "RequireUsername",
  TwoFactorAuthentication = "TwoFactorAuthentication",
  SmsVerificationRequired = "SmsVerificationRequired",
  UpdatePersonalData = "UpdatePersonalData",
  VerifyOTP = "VerifyOTP",
}

export enum Storage {
  Lang = "i18nextLng",
  ClientName = "clientName",
  ClientCode = "clientCode",
  FullName = "fullName",
  Email = "email",
  Tin = "tin",
  IsAuth = "isAuth",
  PhoneNumber = "phoneNumber",
  BrowserName = "browserName",
  BrowserVersion = "browserVersion",
  BrowserOs = "browserOs",
}

export enum StatusCode {
  Unauthorized = 401,
}

export enum BeneficiaryType {
  Account = "Account",
  Card = "Card"
}

export enum Currencies {
  AMD = "AMD",
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
  RUB = "RUB",
  JPY = "JPY",
  INR = "INR",
  CNY = "CNY",
  KRW = "KRW",
  AED = "AED",
  CHF = "CHF",
  AUD = "AUD",
  SEK = "SEK",
  PLN = "PLN",
  CAD = "CAD",
  GEL = "GEL",
  XAU = "XAU",
  BHD = "BHD",
}

export enum TransactionDirection {
  In = "In",
  Out = "Out",
}

export enum UiType {
  Success = "success-dark",
  Danger = "danger-light",
}


export enum SnackbarAlertTypes {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "information",
  Grey = "grey",
  discovery = "discovery",
}

export enum HiddenColumns {
  EquivalentInAMD = "equivalent_in_AMD"
}

export enum TermsAndConditionsLang {
  en = "_eng",
  ru = "_rus",
  hy = "",
}

export enum ErrorMessages {
  RequiredField = "errorMessages.fieldIsRequired",
  InvalidEmail = "errorMessages.invalidEmail",
  InvalidPhone = "errorMessages.invalidPhone",
  OnlyDigits = "errorMessages.onlyDigits",
  TinInvalidLength = "errorMessages.tinInvalidLength",
  SsnInvalidLength = "errorMessages.ssnInvalidLength",
  UnknownAccountHolder = "errorMessages.unknownAccountHolder",
  UnknownCardHolder = "errorMessages.unknownCardHolder",
  MaxLength = "errorMessages.maxLength",
  InvalidCardNumber = "errorMessages.invalidCardNumber",
  MinAmount = "errorMessages.minAmount",
  NotEnoughBalance = "errorMessages.notEnoughBalance",
  CardNumberMustBe = "errorMessages.cardNumberMustBe",
  WrongSymbols = "errorMessages.wrongSymbols",
  MinInput = "errorMessages.minInput",
  MaxInput = "errorMessages.maxInput",
  OnlyNumbers = "errorMessages.onlyNumbers",
  InvalidPurpose = "errorMessages.invalidPurpose",
  MaxBeneficiaryName = "errorMessages.maxBeneficiaryName",
  MinAccountNumber = "errorMessages.minAccountNumber",
  MaxAccountNumber = "errorMessages.maxAccountNumber",
  MinTransactionNumber = "errorMessages.minTransactionNumber",
  MaxTransactionNumber = "errorMessages.maxTransactionNumber",
  MinApplicationNumber = "errorMessages.minApplicationNumber",
  MaxApplicationNumber = "errorMessages.maxApplicationNumber",
  InvalidUsername = "errorMessages.invalidUsername",
  InvalidOtp = "errorMessages.otpInvalid",
  InvalidAccountNumber = "errorMessages.invalidAccountNumber",
  InvalidTin = "errorMessages.invalidTin",
  InvalidOwnTin = "errorMessages.invalidOwnTin",
  InvalidDocumentNumber = "errorMessages.invalidDocumentNumber",
  TechnicalDifficulties = "errorMessages.technicalDifficulties",
  BeneficiaryWrongAccount = "errorMessages.beneficiaryWrongAccount",
  BeneficiaryAtLeastOne = "errorMessages.beneficiaryAtLeastOne",
  BeneficiaryDuplicate = "errorMessages.beneficiaryDuplicate",
  MustBeAccepted = "errorMessages.mustBeAccepted",
  TryAgainShortly = "errorMessages.tryAgainShortly",
  FileSize = "errorMessages.fileSize",
  FileType = "errorMessages.fileType",
  EndDate = "errorMessages.endDate",
  MaxAmount = "errorMessages.maxAmount",
  DuplicateBeneficiaryNumber = "errorMessages.duplicateBeneficiaryNumber",
  DuplicateBeneficiaryClientCode = "errorMessages.duplicateBeneficiaryClientCode",
  GeneralApiError = "errorMessages.generalApiError",
  DifferentClient = "errorMessages.differentClient",
  BeneficiaryNameMustContainLetter = "errorMessages.beneficiaryNameMustContainLetter",
  InvalidMessageLine = "errorMessages.invalidMessageLine",
  MaxMessageLine = "errorMessages.maxMessageLine",
  MessageLineInvalidPrefix = "errorMessages.messageLineInvalidPrefix",
}

export enum ResponseType {
  Blob = "blob",
}

export enum TableNames {
  ApplicationHistory = "application-history",
  AccountHistory = "account-history",
  CardHistory = "card-history",
  CardOnlineHistory = "card-online-history",
  LoanHistory = "loan-history",
  LoanSchedule = "loan-schedule",
  DepositHistory = "deposit-history",
  DepositSchedule = "deposit-schedule",
  TransactionHistory = "transaction-history",
}

export enum DownloadType {
  Csv = "Csv",
  Pdf = "Pdf",
  Excel = "Excel",
}

export enum CloudflareAsset {
  ARE = "ARE",
  ARM = "ARM",
  AUS = "AUS",
  CAN = "CAN",
  CHE = "CHE",
  CHN = "CHN",
  EUR = "EUR",
  GBR = "GBR",
  GEL = "GEL",
  IND = "IND",
  JPN = "JPN",
  KOR = "KOR",
  RUS = "RUS",
  SWE = "SWE",
  USA = "USA",
  XAU = "XAU",
  Add = "Add",
  AddLight = "AddLight",
  Account = "Account",
  AccountDisabled = "AccountDisabled",
  Sign = "Sign",
  SignLight = "SignLight",
  Save = "Save",
  Edit = "Edit",
  Hamburger = "Hamburger",
  Info = "Info",
  EyeOpen = "EyeOpen",
  EyeClose = "EyeClose",
  EyeOpenLight = "EyeOpenLight",
  EyeCloseLight = "EyeCloseLight",
  Refresh = "Refresh",
  ArrowShortLeft = "ArrowShortLeft",
  ArrowShortRight = "ArrowShortRight",
  ArrowShortUp = "ArrowShortUp",
  ArrowShortDown = "ArrowShortDown",
  ArrowLongLeft = "ArrowLongLeft",
  ArrowShortDownLight = "ArrowShortDownLight",
  ArrowShortDownQuaternary = "ArrowShortDownQuaternary",
  ArrowShortUpLight = "ArrowShortUpLight",
  ArrowShortUpQuaternary = "ArrowShortUpQuaternary",
  MyAmeriaLogo = "MyAmeriaLogo",
  History = "History",
  Card = "Card",
  Main = "Main",
  Transfer = "Transfer",
  Loan = "Loan",
  LoanDangerLight = "LoanDangerLight",
  DocumentList = "DocumentList",
  DocumentDeclaration = "DocumentDeclaration",
  Warning = "Warning",
  OwnAccountTransfer = "OwnAccountTransfer",
  AccountTransfer = "AccountTransfer",
  InternationalTransfer = "InternationalTransfer",
  CurrencyExchange = "CurrencyExchange",
  CurrencyExchangeArrows = "CurrencyExchangeArrows",
  Currencies = "Currencies",
  BudgetTransfer = "BudgetTransfer",
  CardTransfer = "CardTransfer",
  GroupTransfer = "GroupTransfer",
  SelectedOption = "SelectedOption",
  Trash = "Trash",
  Star = "Star",
  AccountOpeningApplication = "AccountOpeningApplication",
  AccountClosureApplication = "AccountClosureApplication",
  PhoneBankingApplication = "PhoneBankingApplication",
  PayrollCardOpeningApplication = "PayrollCardOpeningApplication",
  PeriodicalPaymentsApplication = "PeriodicalPaymentsApplication",
  CardServiceInstructionApplication = "CardServiceInstructionApplication",
  LoanTrancheDisbursementApplication = "LoanTrancheDisbursementApplication",
  UserOpeningApplication = "UserOpeningApplication",
  DepositTerminationApplication = "DepositTerminationApplication",
  Application = "Application",
  ClassicCard = "ClassicCard",
  PlatinumCard = "PlatinumCard",
  DefaultCard = "DefaultCard",
  Visa = "Visa",
  MasterCard = "MasterCard",
  ArCa = "ArCa",
  VisaSmall = "VisaSmall",
  MasterCardSmall = "MasterCardSmall",
  ArCaSmall = "ArCaSmall",
  QRScanner = "QRScanner",
  EmptyContent = "EmptyContent",
  Error = "Error",
  Calendar = "Calendar",
  LoanRepayment = "LoanRepayment",
  TopUp = "TopUp",
  Rename = "Rename",
  StopLight = "StopLight",
  Beneficiaries = "Beneficiaries",
  AddGrey = "AddGrey",
  Search = "Search",
  ProfileGroupGreen = "ProfileGroupGreen",
}

export enum SideSheetPosition {
  Right = "right",
  Left = "left",
  Bottom = "bottom",
}

export enum FeatureToggle {
  isCardTransferAvailable = "isCardTransferAvailable",
  isCardTransferUpdateAvailable = "isCardTransferUpdateAvailable",
  isCardTransferCopyAvailable = "isCardTransferCopyAvailable",
  isCardStatementAvailable = "isCardStatementAvailable",
  isBudgetTransferAvailable = "isBudgetTransferAvailable",
  isBudgetTransferUpdateAvailable = "isBudgetTransferUpdateAvailable",
  isBudgetTransferCopyAvailable = "isBudgetTransferCopyAvailable",
  isDepositScheduleAvailable = "isDepositScheduleAvailable",
  isDepositStatementAvailable = "isDepositStatementAvailable",
  isLoanScheduleAvailable = "isLoanScheduleAvailable",
  isLoanStatementAvailable = "isLoanStatementAvailable",
  isAccountTransferAvailable = "isAccountTransferAvailable",
  isAccountTransferUpdateAvailable = "isAccountTransferUpdateAvailable",
  isAccountTransferCopyAvailable = "isAccountTransferCopyAvailable",
  isAccountStatementAvailable = "isAccountStatementAvailable",
  isAccountRequisiteAvailable = "isAccountRequisiteAvailable",
  isOwnAccountTransferAvailable = "isOwnAccountTransferAvailable",
  isOwnAccountTransferUpdateAvailable = "isOwnAccountTransferUpdateAvailable",
  isOwnAccountTransferCopyAvailable = "isOwnAccountTransferCopyAvailable",
  isCurrencyExchangeAvailable = "isCurrencyExchangeAvailable",
  isCurrencyExchangeUpdateAvailable = "isCurrencyExchangeUpdateAvailable",
  isCurrencyExchangeCopyAvailable = "isCurrencyExchangeCopyAvailable",
  isGroupTransferAvailable = "isGroupTransferAvailable",
  isGroupTransferUpdateAvailable = "isGroupTransferUpdateAvailable",
  isGroupTransferCopyAvailable = "isGroupTransferCopyAvailable",
  isAccountOpeningApplicationAvailable = "isAccountOpeningApplicationAvailable",
  isAccountClosureApplicationAvailable = "isAccountClosureApplicationAvailable",
  isPhoneBankingApplicationAvailable = "isPhoneBankingApplicationAvailable",
  isPayrollCardOpeningApplicationAvailable = "isPayrollCardOpeningApplicationAvailable",
  isLoanTrancheDisbursementApplicationAvailable = "isLoanTrancheDisbursementApplicationAvailable",
  isPaymentCardServiceInstructionApplicationAvailable = "isPaymentCardServiceInstructionApplicationAvailable",
  isPeriodicalPaymentsApplicationAvailable = "isPeriodicalPaymentsApplicationAvailable",
  isUserOpeningApplicationAvailable = "isUserOpeningApplicationAvailable",
  isDepositTerminationApplicationAvailable = "isDepositTerminationApplicationAvailable",
  isLoanRepaymentAvailable = "isLoanRepaymentAvailable",
  isLoanRepaymentUpdateAvailable = "isLoanRepaymentUpdateAvailable",
  isLoanRepaymentCopyAvailable = "isLoanRepaymentCopyAvailable",
  isTemplatesAvailable = "isTemplatesAvailable",
  isBeneficiaryAvailable = "isBeneficiaryAvailable",
  isBudgetTransferTemplateAvailable = "isBudgetTransferTemplateAvailable",
}

export enum NotificationScope {
  Page = "page",
  Modal = "modal",
}

export enum OperationStatus {
  Created = "Created",
  PartiallySigned = "PartiallySigned",
  Signed = "Signed",
  Accepted = "Accepted",
  Completed = "Completed",
  Declined = "Declined",
  Cancelled = "Cancelled",
}

export enum OperationStatusColor {
  Completed = "brand",
  PartiallySigned = "information",
  Created = "information",
  Signed = "information",
  Accepted = "information",
  Declined = "danger",
  Cancelled = "primary",
}

export enum OperationCommand {
  Sign = "Sign",
  Delete = "Delete",
  Copy = "Copy",
  SendToEdit = "SendToEdit",
  Cancel = "Cancel",
  View = "View",
  Export = "Export",
  Edit = "Edit",
}

export enum OperationNextState {
  SendToEdit = "SendToEdit",
  Delete = "Delete",
}

export enum OperationStatusTextColor {
  Completed = "brand-dark",
  PartiallySigned = "information-dark",
  Editable = "danger-dark",
  Signed = "warning-dark",
  Accepted = "warning-dark",
  Created = "information-dark",
  Declined = "primary",
  Cancelled = "primary",
}

export enum CardSubType {
  ArCaCustomsCard = "ArCaCustomsCard",
  MasterBusiness = "MasterBusiness",
  VisaBusiness = "VisaBusiness",
  VisaBusinessDigital = "VisaBusinessDigital",
  MastercardBusinessDigital = "MastercardBusinessDigital",
  VisaPlatinumBusiness = "VisaPlatinumBusiness",
  VisaPlatinumDigital = "VisaPlatinumDigital",
}

export enum ChangeCardType {
  NotApplicable = "NotApplicable",
  ChangeCreditToDebit = "ChangeCreditToDebit",
  ChangeDebitToCredit = "ChangeDebitToCredit",
}

export enum StaticUrl {
  CorporateTariffs = "corporateTariffs",
  TermsAndConditions = "termsAndConditions",
  DepositTermsAndConditions = "depositTermsAndConditions",
  TermsOfCommercialLending = "termsOfCommercialLending",
  CardTerms = "cardTerms",
  CardTariffs = "cardTariffs",
}

export enum AccessManagementKeys {
  AccountTransfer = "AccountTransfer",
  CardTransfer = "CardTransfer",
}

export enum ErrorKeys {
  TransactionRestrictedByStopTool = "TransactionRestrictedByStopTool",
}

export enum SearchParamKeys {
  TemplateId = "templateId",
  ToAccount = "toAccount",
  TemplateName = "templateName",
  LoanContractNumber = "loanContractNumber",
  BeneficiaryNumber = "beneficiaryNumber",
}
